import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard"
export default class extends Controller {
  static values = { text: String, successContent: String }

  static targets = [ "source" ]

  connect() {
  }

  copySpurce(event) {
    event.preventDefault()
    navigator.clipboard.writeText(this.sourceTarget.value)
  }

  copy(event) {
    event.preventDefault()
    const text = this.hasTextValue ? this.textValue : event.params.text
    navigator.clipboard.writeText(text).then(() => {
      if (this.hasSuccessContentValue) {
        const original = this.element.innerHTML
        this.element.innerHTML = this.successContentValue
        setTimeout(() => { this.element.innerHTML = original }, 2000)
      }
    })
  }
}
